import React from "react";
import { useSelector } from "react-redux";
import AboutUsSection from "../../components/about/AboutUS";
import ServicesSubPages from "../residential/ServicesSubPages";
import Cimg1 from "../../assest/Commercial-1.png";
import Cimg2 from "../../assest/Commercial-2.png";
import Cimg3 from "../../assest/Commerical-3.png";
import ServicesCard from "../../components/home/ServicesCard";
import FaqSection from "../../components/about/FAQ";

const Commercial = () => {
  const { language } = useSelector((state) => state.language);

  // Translation objects
  const translations = {
    gb: {
      heading: "Commercial Projects",
      buttonText: "About Us",
      aboutHeading: "About Our Commercial Services",
      aboutText: `Etihad Gharbia Contracting Company is a leading provider of comprehensive contracting and construction services across the Kingdom of Saudi Arabia. With expertise in Contracting, Manpower Supply, Equipment Rental, and Transportation, we specialize in delivering high-quality commercial construction solutions for a wide range of clients including government institutions and private enterprises. Since our founding in 2010, we've built a reputation for professionalism, innovation, and reliability.

Our integrated approach ensures each commercial project is managed with precision—from initial planning through execution—while aligning with Saudi Building Codes and Vision 2030 goals. Whether developing office complexes, retail centers, healthcare facilities, or industrial infrastructure, our experienced team ensures delivery that exceeds client expectations in quality, cost-efficiency, and sustainability.`,
      includedHeading: "What's Included in Our Commercial Services",
      includedItems: [
        "Turnkey construction for offices, retail centers, and commercial complexes",
        "Design coordination and architectural planning with advanced BIM tools",
        "Site development, foundation, and structural work",
        "Complete MEP (Mechanical, Electrical & Plumbing) systems implementation",
        "Interior fit-out including partitions, flooring, ceilings, and finishes",
        "Integration of IT, GPS, and smart building solutions",
        "Strict compliance with Saudi codes, health & safety regulations, and Vision 2030 standards",
        "Project documentation, quality assurance, and site management",
      ],
      customizedHeading: "Why Choose Etihad Gharbia for Commercial Projects",
      customizedItems: [
        "Over a decade of experience serving public and private sector clients across KSA",
        "Trusted by clients such as Saudi Technic, Saudi Arabia Railways, Ministry of Health, and Ministry of Interior",
        "Full-spectrum solutions from manpower to heavy equipment and logistics",
        "Dedicated project managers ensuring timely execution and budget adherence",
        "Customized construction and rental solutions tailored to business requirements",
        "Commitment to sustainability, safety, and cutting-edge technology",
        "Strong supplier network and in-house fleet of modern equipment",
        "24/7 client support and transparent communication throughout the project lifecycle",
      ],
    },
    sa: {
      heading: "المشاريع التجارية",
      buttonText: "معلومات عنا",
      aboutHeading: "حول خدماتنا التجارية",
      aboutText: `شركة اتحاد غربيا للمقاولات هي مزود رائد لخدمات المقاولات والبناء الشاملة في جميع أنحاء المملكة العربية السعودية. مع الخبرة في المقاولات وتوريد العمالة وتأجير المعدات والنقل، نحن متخصصون في تقديم حلول البناء التجارية عالية الجودة لمجموعة واسعة من العملاء بما في ذلك المؤسسات الحكومية والشركات الخاصة. منذ تأسيسنا في عام 2010، بنينا سمعة في الاحترافية والابتكار والموثوقية.

يضمن نهجنا المتكامل إدارة كل مشروع تجاري بدقة - من التخطيط الأولي وحتى التنفيذ - مع الالتزام بأكواد البناء السعودية وأهداف رؤية 2030. سواء كان تطوير مجمعات المكاتب أو مراكز التسوق أو المنشآت الصحية أو البنية التحتية الصناعية، يضمن فريقنا الخبير تقديمًا يتجاوز توقعات العملاء في الجودة والكفاءة من حيث التكلفة والاستدامة.`,
      includedHeading: "ما المدرج في خدماتنا التجارية",
      includedItems: [
        "البناء الشامل للمكاتب ومراكز التسوق والمجمعات التجارية",
        "تنسيق التصميم والتخطيط المعماري باستخدام أدوات BIM المتقدمة",
        "تطوير الموقع والأساس والأعمال الهيكلية",
        "تنفيذ أنظمة MEP (الميكانيكية والكهربائية والسباكة) الكاملة",
        "التجهيزات الداخلية بما في ذلك الفواصل والأرضيات والأسقف والنهائيات",
        "تكامل حلول تكنولوجيا المعلومات ونظام تحديد المواقع والمباني الذكية",
        "الامتثال الصارم للقوانين السعودية وأنظمة الصحة والسلامة ومعايير رؤية 2030",
        "توثيق المشروع وضمان الجودة وإدارة الموقع",
      ],
      customizedHeading: "لماذا تختار اتحاد غربيا للمشاريع التجارية",
      customizedItems: [
        "أكثر من عقد من الخبرة في خدمة عملاء القطاعين العام والخاص في جميع أنحاء المملكة",
        "موثوق به من قبل عملاء مثل السعودية للتقنية وسكك الحديد السعودية ووزارة الصحة ووزارة الداخلية",
        "حلول شاملة من توريد العمالة إلى المعدات الثقيلة والخدمات اللوجستية",
        "مديرو مشاريع مخصصون يضمنون التنفيذ في الوقت المحدد والالتزام بالميزانية",
        "حلول بناء وتأجير مخصصة مصممة وفقًا لمتطلبات العمل",
        "التزام بالاستدامة والسلامة والتكنولوجيا المتطورة",
        "شبكة موردين قوية وأسطول داخلي من المعدات الحديثة",
        "دعم العملاء على مدار الساعة واتصال شفاف طوال دورة حياة المشروع",
      ],
    },
    fr: {
      heading: "Projets Commerciaux",
      buttonText: "À propos de nous",
      aboutHeading: "À propos de nos services commerciaux",
      aboutText: `Etihad Gharbia Contracting Company est un fournisseur leader de services complets de contrat et de construction à travers le Royaume d'Arabie Saoudite. Avec une expertise en Contrat, Fourniture de Main-d'œuvre, Location d'Équipement et Transport, nous nous spécialisons dans la fourniture de solutions de construction commerciale de haute qualité pour un large éventail de clients, y compris les institutions gouvernementales et les entreprises privées. Depuis notre fondation en 2010, nous avons bâti une réputation de professionnalisme, d'innovation et de fiabilité.

Notre approche intégrée garantit que chaque projet commercial est géré avec précision - de la planification initiale à l'exécution - tout en s'alignant sur les Codes de Construction Saoudiens et les objectifs de la Vision 2030. Que ce soit le développement de complexes de bureaux, de centres commerciaux, d'établissements de santé ou d'infrastructures industrielles, notre équipe expérimentée assure une livraison qui dépasse les attentes des clients en termes de qualité, d'efficacité et de durabilité.`,
      includedHeading: "Ce qui est inclus dans nos services commerciaux",
      includedItems: [
        "Construction clé en main pour bureaux, centres commerciaux et complexes commerciaux",
        "Coordination de conception et planification architecturale avec outils BIM avancés",
        "Aménagement du site, fondations et travaux structurels",
        "Mise en œuvre complète des systèmes MEP (Mécanique, Électricité et Plomberie)",
        "Aménagement intérieur incluant cloisons, revêtements de sol, plafonds et finitions",
        "Intégration de solutions informatiques, GPS et bâtiments intelligents",
        "Conformité stricte aux codes saoudiens, réglementations de santé et sécurité et normes Vision 2030",
        "Documentation de projet, assurance qualité et gestion de site",
      ],
      customizedHeading: "Pourquoi choisir Etihad Gharbia pour les projets commerciaux",
      customizedItems: [
        "Plus d'une décennie d'expérience au service des clients des secteurs public et privé à travers le KSA",
        "Reconnu par des clients tels que Saudi Technic, Saudi Arabia Railways, Ministry of Health et Ministry of Interior",
        "Solutions complètes de la main-d'œuvre aux équipements lourds et à la logistique",
        "Chefs de projet dédiés garantissant une exécution rapide et le respect du budget",
        "Solutions de construction et de location personnalisées adaptées aux besoins des entreprises",
        "Engagement envers la durabilité, la sécurité et les technologies de pointe",
        "Réseau solide de fournisseurs et flotte interne d'équipements modernes",
        "Support client 24/7 et communication transparente tout au long du cycle de vie du projet",
      ],
    },
    de: {
      heading: "Gewerbliche Projekte",
      buttonText: "Über uns",
      aboutHeading: "Über unsere gewerblichen Dienstleistungen",
      aboutText: `Etihad Gharbia Contracting Company ist ein führender Anbieter von umfassenden Vertrags- und Baudienstleistungen im gesamten Königreich Saudi-Arabien. Mit Fachwissen in den Bereichen Vertragsabwicklung, Arbeitskräftebereitstellung, Gerätevermietung und Transport sind wir auf die Lieferung hochwertiger gewerblicher Baukösungen für eine Vielzahl von Kunden, einschließlich staatlicher Einrichtungen und privater Unternehmen, spezialisiert. Seit unserer Gründung im Jahr 2010 haben wir uns einen Ruf für Professionalität, Innovation und Zuverlässigkeit erarbeitet.

Unser integrierter Ansatz stellt sicher, dass jedes gewerbliche Projekt präzise verwaltet wird - von der ersten Planung bis zur Ausführung - während gleichzeitig die saudischen Bauvorschriften und die Ziele der Vision 2030 eingehalten werden. Ob Entwicklung von Bürokomplexen, Einkaufszentren, Gesundheitseinrichtungen oder Industrieinfrastruktur - unser erfahrenes Team stellt eine Lieferung sicher, die die Kundenerwartungen in Bezug auf Qualität, Kosteneffizienz und Nachhaltigkeit übertrifft.`,
      includedHeading: "Was in unseren gewerblichen Dienstleistungen enthalten ist",
      includedItems: [
        "Schlüsselfertiger Bau von Büros, Einkaufszentren und Gewerbekomplexen",
        "Designkoordination und architektonische Planung mit fortschrittlichen BIM-Tools",
        "Geländeentwicklung, Fundament- und Strukturarbeiten",
        "Vollständige Implementierung von MEP-Systemen (Mechanik, Elektrik und Sanitär)",
        "Innenausbau einschließlich Trennwänden, Bodenbelägen, Decken und Oberflächen",
        "Integration von IT-, GPS- und Smart-Building-Lösungen",
        "Strikte Einhaltung saudischer Vorschriften, Gesundheits- und Sicherheitsbestimmungen und Vision 2030-Standards",
        "Projektdokumentation, Qualitätssicherung und Baustellenmanagement",
      ],
      customizedHeading: "Warum Etihad Gharbia für gewerbliche Projekte wählen",
      customizedItems: [
        "Über ein Jahrzehnt Erfahrung in der Betreuung von Kunden aus dem öffentlichen und privaten Sektor in ganz KSA",
        "Vertrauenswürdig für Kunden wie Saudi Technic, Saudi Arabia Railways, Ministry of Health und Ministry of Interior",
        "Komplettlösungen von Arbeitskräften über schwere Geräte bis hin zur Logistik",
        "Dedizierte Projektmanager, die eine termingerechte Ausführung und Budgeteinhaltung gewährleisten",
        "Maßgeschneiderte Bau- und Mietlösungen, die auf die Geschäftsanforderungen zugeschnitten sind",
        "Engagement für Nachhaltigkeit, Sicherheit und Spitzentechnologie",
        "Starkes Lieferantennetzwerk und eigene Flotte moderner Geräte",
        "24/7-Kundensupport und transparente Kommunikation während des gesamten Projektlebenszyklus",
      ],
    },
  };

  // Get translations for current language (default to English if language not found)
  const t = translations[language] || translations.gb;

  return (
    <>
      <AboutUsSection
        heading={t.heading}
        buttonText={t.buttonText}
      />
      <ServicesSubPages
        aboutHeading={t.aboutHeading}
        aboutText={t.aboutText}
        images={[Cimg1, Cimg2, Cimg3]}
        includedHeading={t.includedHeading}
        includedItems={t.includedItems}
        customizedHeading={t.customizedHeading}
        customizedItems={t.customizedItems}
      />
      <ServicesCard />
      <FaqSection />
    </>
  );
};

export default Commercial;  